/* eslint-disable camelcase */
import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
    selectCurrentEmpid,
    selectCurrentUserManagerLevel,
    selectIsPseudoSupervisor,
    selectedUserCount,
} from '../../pages/login/authSlice';
import { getRole } from '../../utils/roleUtils';
import './MoodMeter.scss';
import { MainMoodMeterModal } from './mainMoodMeterModal/MainMoodMeterModal';

interface MoodMeterProps {
    showModal: boolean;
    managerNumber: string | null | undefined;
    closeModal: () => void;
}

const MoodMeter = ({ showModal, managerNumber, closeModal }: MoodMeterProps) => {
    const [visible, setVisible] = useState(false);
    const [moodMeterOverlayClosable, setMoodMeterOverlayClosable] = useState(false);
    const userCount = useSelector(selectedUserCount);
    const empNum = useSelector(selectCurrentEmpid);
    const userRole = getRole(
        useSelector(selectCurrentUserManagerLevel),
        useSelector(selectIsPseudoSupervisor)
    );

    useEffect(() => {
        if (showModal) {
            setVisible(true);
            setMoodMeterOverlayClosable(true);
        }
    }, [showModal]);

    useEffect(() => {
        let timerOmerlay: NodeJS.Timeout;
        let timerClose: NodeJS.Timeout;

        if (userCount === 0) {
            timerOmerlay = setTimeout(() => {
                setVisible(true);
                setMoodMeterOverlayClosable(false);
            }, 600);
        } else {
            timerClose = setTimeout(() => {
                setVisible(false);
                setMoodMeterOverlayClosable(true);
            }, 500);
        }

        return () => {
            clearTimeout(timerOmerlay);
            clearTimeout(timerClose);
        };
    }, [userCount]);

    const DialogIsClosable = () =>
        !(moodMeterOverlayClosable === false && (userRole === 'associate' || userRole === 'supervisor'));

    return (
        <Dialog
            header="How are you?"
            visible={visible}
            className="moodMeterModal"
            closable={DialogIsClosable()}
            onHide={() => {
                closeModal();
                setVisible(false);
            }}
        >
            <div className="containerMainMood">
                <MainMoodMeterModal
                    onCloseModal={() => {
                        closeModal();
                        setVisible(false);
                    }}
                    empNum={empNum}
                    supervisorId={managerNumber}
                />
            </div>
        </Dialog>
    );
};

export default MoodMeter;
